import { Component } from "@angular/core";

@Component({
	selector: 'app-league-interviews-summary-report',
	templateUrl: './league-interviews-summary-report.component.html'
})
export class LeagueInterviewsSummaryReportComponent { }